import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { HeadCell } from '../styled/TableHead';

var TableHeadCell = function (_Component) {
  _inherits(TableHeadCell, _Component);

  function TableHeadCell() {
    _classCallCheck(this, TableHeadCell);

    return _possibleConstructorReturn(this, (TableHeadCell.__proto__ || _Object$getPrototypeOf(TableHeadCell)).apply(this, arguments));
  }

  _createClass(TableHeadCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          inlineStyles = _props.inlineStyles,
          restCellProps = _objectWithoutProperties(_props, ['content', 'inlineStyles']);

      return React.createElement(
        HeadCell,
        _extends({}, restCellProps, { style: inlineStyles }),
        React.createElement(
          'span',
          null,
          content
        )
      );
    }
  }]);

  return TableHeadCell;
}(Component);

TableHeadCell.defaultProps = {
  innerRef: function innerRef() {},
  inlineStyles: {}
};


export default TableHeadCell;